import React from 'react';
// JSS
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { Button, Row, Col } from "react-bootstrap"; // Design System

import Heading from '../heading/Heading';
import CTALink from '../forms/elements/CTALink';
import ImageLoader from '../images/ImageLoader';
import { impressionsGA, gaTracker, promoClickImpression } from '../../util';

var gaLink = function gaLink(model) {
  var _model$title, _model$title$value, _model$title2, _model$title2$value, _model$link, _model$link$value;

  var data = {
    gtm: {
      uniqueEventId: '47',
      elementTarget: model === null || model === void 0 ? void 0 : (_model$title = model.title) === null || _model$title === void 0 ? void 0 : (_model$title$value = _model$title.value) === null || _model$title$value === void 0 ? void 0 : _model$title$value.href,
      elementTitle: model === null || model === void 0 ? void 0 : (_model$title2 = model.title) === null || _model$title2 === void 0 ? void 0 : (_model$title2$value = _model$title2.value) === null || _model$title2$value === void 0 ? void 0 : _model$title2$value.title,
      elementId: "card-".concat(model === null || model === void 0 ? void 0 : (_model$link = model.link) === null || _model$link === void 0 ? void 0 : (_model$link$value = _model$link.value) === null || _model$link$value === void 0 ? void 0 : _model$link$value.id)
    },
    event: 'gtm.click'
  };
  gaTracker(data);
};

var Card = function Card(props) {
  var _model$image, _model$image$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      isTimeline = props.isTimeline,
      _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct,
      _props$promoIndex = props.promoIndex,
      promoIndex = _props$promoIndex === void 0 ? 0 : _props$promoIndex;
  var imagecase = Boolean((_model$image = model.image) === null || _model$image === void 0 ? void 0 : (_model$image$value = _model$image.value) === null || _model$image$value === void 0 ? void 0 : _model$image$value.src);
  return imagecase ? /*#__PURE__*/React.createElement(WImage, {
    isEditing: isEditing,
    model: model,
    timeline: isTimeline,
    children: props.children,
    className: props.className,
    isPromoProduct: isPromoProduct
  }) : /*#__PURE__*/React.createElement(WoImage, {
    model: model,
    isPromoProduct: isPromoProduct
  });
};

var WImage = function WImage(props) {
  var _model$link2, _model$link2$value, _model$color, _model$color2, _model$color3, _model$link3, _model$link3$value;

  var _props$model2 = props.model,
      model = _props$model2 === void 0 ? {} : _props$model2,
      timeline = props.timeline,
      propChildren = props.children,
      parentClassName = props.className,
      _props$isEditing2 = props.isEditing,
      isEditing = _props$isEditing2 === void 0 ? false : _props$isEditing2,
      _props$isPromoProduct2 = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct2 === void 0 ? false : _props$isPromoProduct2,
      _props$promoIndex2 = props.promoIndex,
      promoIndex = _props$promoIndex2 === void 0 ? 0 : _props$promoIndex2;
  var hyperLink = ((_model$link2 = model.link) === null || _model$link2 === void 0 ? void 0 : (_model$link2$value = _model$link2.value) === null || _model$link2$value === void 0 ? void 0 : _model$link2$value.href) ? model.link : {
    value: {
      href: "javascript:void(0)"
    }
  };
  var children = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: isEditing,
    media: model.image,
    className: "cb-card__image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-card__copy-container"
  }, propChildren, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: model.title,
    className: "cb-card__title"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: model.subtitle,
    className: "cb-card__subtitle"
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: model.text,
    className: "cb-card__text"
  })));
  var className = "cb-card ".concat(typeof ((_model$color = model.color) === null || _model$color === void 0 ? void 0 : _model$color.value) !== 'undefined' && ((_model$color2 = model.color) === null || _model$color2 === void 0 ? void 0 : _model$color2.value) !== '' ? "cb-bg-color-".concat((_model$color3 = model.color) === null || _model$color3 === void 0 ? void 0 : _model$color3.value) : '');
  var curserClassName = ((_model$link3 = model.link) === null || _model$link3 === void 0 ? void 0 : (_model$link3$value = _model$link3.value) === null || _model$link3$value === void 0 ? void 0 : _model$link3$value.href) ? 'cursor-link-ponter' : 'cursor-link-default';

  if (timeline) {
    var _model$color4, _model$color5;

    return /*#__PURE__*/React.createElement("div", {
      field: hyperLink,
      className: "\n      cb-card__timelinecard\n      ".concat(parentClassName, "\n      ").concat(className, "\n      "),
      style: {
        backgroundColor: "".concat(((_model$color4 = model.color) === null || _model$color4 === void 0 ? void 0 : _model$color4.value) ? (_model$color5 = model.color) === null || _model$color5 === void 0 ? void 0 : _model$color5.value : '')
      }
    }, children);
  } else {
    var _model$link4, _model$link4$value, _model$color6, _model$color7;

    return /*#__PURE__*/React.createElement(SitecoreLink, {
      field: hyperLink,
      className: "\n      ".concat(className, " ").concat(curserClassName, "\n      "),
      id: "card-".concat(model === null || model === void 0 ? void 0 : (_model$link4 = model.link) === null || _model$link4 === void 0 ? void 0 : (_model$link4$value = _model$link4.value) === null || _model$link4$value === void 0 ? void 0 : _model$link4$value.id),
      style: {
        backgroundColor: "".concat(((_model$color6 = model.color) === null || _model$color6 === void 0 ? void 0 : _model$color6.value) ? (_model$color7 = model.color) === null || _model$color7 === void 0 ? void 0 : _model$color7.value : '')
      },
      onClick: function onClick() {
        var _props$model3, _props$model3$image, _props$model3$image$v;

        var promoObj = {
          id: 'un_named-promo',
          name: props === null || props === void 0 ? void 0 : (_props$model3 = props.model) === null || _props$model3 === void 0 ? void 0 : (_props$model3$image = _props$model3.image) === null || _props$model3$image === void 0 ? void 0 : (_props$model3$image$v = _props$model3$image.value) === null || _props$model3$image$v === void 0 ? void 0 : _props$model3$image$v.alt,
          creative: '',
          position: '',
          destinationUrl: props.model.link.value.href,
          index: ''
        };

        if (isPromoProduct) {
          promoClickImpression(promoObj);
        } else {
          var _model$link5, _model$link5$value, _model$link6, _model$link6$value;

          ((_model$link5 = model.link) === null || _model$link5 === void 0 ? void 0 : (_model$link5$value = _model$link5.value) === null || _model$link5$value === void 0 ? void 0 : _model$link5$value.href) != "" && ((_model$link6 = model.link) === null || _model$link6 === void 0 ? void 0 : (_model$link6$value = _model$link6.value) === null || _model$link6$value === void 0 ? void 0 : _model$link6$value.href) ? gaLink(model) : "javascript:void(0)";
        }
      }
    }, children);
  }
};

var WoImage = function WoImage(_ref) {
  var _model$color8, _model$color9, _model$color10, _model$color11, _model$color12, _model$value;

  var oldModel = _ref.model,
      timeline = _ref.timeline;

  var setModel = function setModel(settingmodel) {
    var newModel = {
      color: settingmodel.color,
      title: settingmodel.title,
      text: settingmodel.text,
      link: settingmodel.link1 || settingmodel.link || {
        value: {}
      },
      linkType: settingmodel.linkType || "default"
    };
    newModel.link.value.class = "";
    return newModel;
  };

  var model = setModel(oldModel);
  return /*#__PURE__*/React.createElement("div", {
    className: "\n    cb-card\n    ".concat(typeof ((_model$color8 = model.color) === null || _model$color8 === void 0 ? void 0 : _model$color8.value) !== 'undefined' && ((_model$color9 = model.color) === null || _model$color9 === void 0 ? void 0 : _model$color9.value) !== '' ? "cb-bg-color-".concat((_model$color10 = model.color) === null || _model$color10 === void 0 ? void 0 : _model$color10.value) : '', "\n    cb-card--noimage\n    ").concat(timeline ? "cb-card__timelinecard" : "", "\n  "),
    style: {
      backgroundColor: "".concat(((_model$color11 = model.color) === null || _model$color11 === void 0 ? void 0 : _model$color11.value) ? (_model$color12 = model.color) === null || _model$color12 === void 0 ? void 0 : _model$color12.value : '')
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__copy-container"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: model.title,
    alignment: "center",
    className: "cb-card__title"
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: model.text,
    alignment: "center",
    className: "cb-card__text"
  }), /*#__PURE__*/React.createElement(CTALink, {
    onClick: function onClick() {
      return gaLink(model);
    },
    ctaLink: model.link,
    id: "card-".concat(model === null || model === void 0 ? void 0 : (_model$value = model.value) === null || _model$value === void 0 ? void 0 : _model$value.id),
    alignment: "center",
    linkType: model.linkType,
    containerClass: "cb-card__cta"
  })));
};

export default Card;